import React  from 'react';
import Product_Card from './Product_Card';
import Slider_Big from './Slider_Big';
import Slider_Small from './Slider_Small';
import Product_List from './Product_List';
import View_Search from './View_Search';
import View_SearchAutocom from './View_SearchAutocom';

 const Root_Content = ({addToCart,addToFavorites} ) => {


    return (
        <div className="my-content">
        {/* <View_Search/> */}           
        {/*  <Slider_Big/> */}        
        
         <div className='xcontainer-xl'>
         <div className='product-list row py-3'>         
         <Product_List addToCart={addToCart} addToFavorites={addToFavorites}/>
         </div>
         </div>

        </div>
      );
};

export default Root_Content;